export default __webpack_public_path__ + "static/media/shopping-cart.415b95e4.png";